
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import NewPageLoader from "@/views/NewPageLoader.vue";
import { serviceOptions } from "@/models/common";
import Swal from "sweetalert2";

@Component({ components: { NewPageLoader } })
export default class PortalSettings extends Vue {
  public newPageLoader = true;
  public serviceLits = null;
  public serviceOptions = new serviceOptions();
  public loginSlider1 = null;
  public loginSlider2 = null;
  public loginSlider3 = null;
  public imageSrc = null;
  public imageFile = null;

  //Get Portal Settings
  public async getPortalSettings() {
    this.newPageLoader = true;
    let response = await Axios.get(API_STORE.CONFIG + "getPortalSettings", {
      headers: getAPIAuthorizedHeader(),
    });
    this.newPageLoader = false;
    if (response) {
      this.serviceLits = response.data.settings[0];
      this.serviceOptions.recharge = response.data.settings[0].recharge;
      this.serviceOptions.billPay = response.data.settings[0].billPay;
      this.serviceOptions.dmt = response.data.settings[0].dmt;
      this.serviceOptions.upi = response.data.settings[0].upi;
      this.serviceOptions.aeps = response.data.settings[0].aeps;
      this.serviceOptions.otpSms = response.data.settings[0].otpSms;
      this.serviceOptions.phonepeGateway = response.data.settings[0].phonepeGateway;
      this.serviceOptions.id = response.data.settings[0]._id;
      this.serviceOptions.dmt1 = response.data.settings[0].dmt1;
      this.serviceOptions.dmt2 = response.data.settings[0].dmt2;
      this.serviceOptions.dmt3 = response.data.settings[0].dmt3;
      this.serviceOptions.upi1 = response.data.settings[0].upi1;
      this.serviceOptions.upi2 = response.data.settings[0].upi2;
      this.loginSlider1 =
        process.env.VUE_APP_AWS_S3_URL + response.data.settings[0].loginSlider1;
      this.loginSlider2 =
        process.env.VUE_APP_AWS_S3_URL + response.data.settings[0].loginSlider2;
      this.loginSlider3 =
        process.env.VUE_APP_AWS_S3_URL + response.data.settings[0].loginSlider3;
    }
  }

  //Update Service Controll
  public async updateServiceControl(type, value) {
    this.newPageLoader = true;
    if (type === "Recharge") {
      console.log(type, value, "::::::", this.serviceOptions.recharge);
      this.serviceOptions.recharge = this.serviceOptions.recharge
        ? false
        : true;
    }
    if (type === "BillPay") {
      console.log(type, value, "::::::", this.serviceOptions.billPay);
      this.serviceOptions.billPay = this.serviceOptions.billPay ? false : true;
    }
    if (type === "DMT") {
      console.log(type, value, "::::::", this.serviceOptions.dmt);
      this.serviceOptions.dmt = this.serviceOptions.dmt ? false : true;
    }
    if (type === "DMT1") {
      console.log(type, value, "::::::", this.serviceOptions.dmt1);
      this.serviceOptions.dmt1 = this.serviceOptions.dmt1 ? false : true;
    }
    if (type === "DMT2") {
      console.log(type, value, "::::::", this.serviceOptions.dmt2);
      this.serviceOptions.dmt2 = this.serviceOptions.dmt2 ? false : true;
    }
    if (type === "DMT3") {
      console.log(type, value, "::::::", this.serviceOptions.dmt3);
      this.serviceOptions.dmt3 = this.serviceOptions.dmt3 ? false : true;
    }
    if (type === "UPI") {
      console.log(type, value, "::::::", this.serviceOptions.upi);
      this.serviceOptions.upi = this.serviceOptions.upi ? false : true;
    }
    if (type === "UPI1") {
      console.log(type, value, "::::::", this.serviceOptions.upi1);
      this.serviceOptions.upi1 = this.serviceOptions.upi1 ? false : true;
    }
    if (type === "UPI2") {
      console.log(type, value, "::::::", this.serviceOptions.upi2);
      this.serviceOptions.upi2 = this.serviceOptions.upi2 ? false : true;
    }
    if (type === "AEPS") {
      console.log(type, value, "::::::", this.serviceOptions.aeps);
      this.serviceOptions.aeps = this.serviceOptions.aeps ? false : true;
    }
    if (type === "OTPSMS") {
      console.log(type, value, "::::::", this.serviceOptions.otpSms);
      this.serviceOptions.otpSms = this.serviceOptions.otpSms ? false : true;
    }
    if (type === "PHONEPE") {
      console.log(type, value, "::::::", this.serviceOptions.phonepeGateway);
      this.serviceOptions.phonepeGateway = this.serviceOptions.phonepeGateway ? false : true;
    }

    this.serviceOptions.servicetype = type;

    //Update Services
    let response = await Axios.post(
      API_STORE.CONFIG + "updatePortalSetting",
      { ...this.serviceOptions },
      {
        headers: getAPIAuthorizedHeader(),
      }
    );
    this.newPageLoader = false;
    if (response) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: response.data.message,
        showConfirmButton: true,
      });
    }
  }

  //Uplaod Images
  public async fileChangeEvent(event, fileNumber) {
    this.newPageLoader = true;
    this.imageSrc = URL.createObjectURL(event.target.files[0]);
    this.imageFile = event.target.files[0];
    console.log(this.imageSrc, this.imageFile, fileNumber);

    if (this.imageFile != null) {
      let formData = new FormData();
      formData.append("file", this.imageFile);

      let response = await Axios.post(
        API_STORE.CONFIG + "updateLoginSliders",
        formData,
        {
          params: {
            fileNumber: fileNumber,
            settingId: this.serviceOptions.id,
          },
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.newPageLoader = false;

      if (response) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: true,
        });
        console.log(response.data);
        this.getPortalSettings();
      }
    } else {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Something wrong!",
        showConfirmButton: true,
      });
      this.newPageLoader = false;
    }
  }

  mounted() {
    this.getPortalSettings();
    this.newPageLoader = false;
  }
}
